
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.43 1.5L3.31 7.218a.609.609 0 00.043.504c.043.073.101.133.169.175a.426.426 0 00.221.065h2.629L4.487 15.5l8.095-8.766a.562.562 0 00.133-.274.611.611 0 00-.022-.312.533.533 0 00-.17-.245.432.432 0 00-.262-.095H8.728L10.612 1.5H5.43z","fill":"url(#paint0_linear_20116_98456)","stroke":"#69EE86","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear_20116_98456","x1":"7.787","y1":"11.325","x2":"7.366","y2":"-10.165","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":".115","stop-color":"#46D064"}}),_c('stop',{attrs:{"offset":".115","stop-color":"#141F31","stop-opacity":"0"}})])])])
          )
        }
      }
    